import{jsx as t}from"react/jsx-runtime";import{lightTheme as i}from"@caelor/ui";import{useDexContext as e}from"../../providers/DexContext.js";import o from"../../template/Template.js";import r,{ThemeProvider as n}from"styled-components";const c=r.div`
	width: ${({previewWidth:t})=>t}px;
	height: auto;
	zoom: ${({zoomFactor:t})=>t};
	overflow: visible;
	cursor: ${({canEdit:t})=>t?"auto":"pointer"};
	pointer-events: ${({canEdit:t})=>t?"auto":"none"};
`,d=r.div`
	width: 1052px;
	height: auto;
	object-fit: contain;
	outline: ${({isActiveBlock:t})=>t?"6px solid rgba(0, 175, 255, 0.15)":"none"};
	border-radius: 3px;

	& > div:first-child {
		border-radius: 3px;
		overflow: hidden;
	}

	p,
	div[contenteditable="true"] {
		outline: none;
	}

	a {
		color: inherit;
	}
`,a=({block:r,previewWidth:a=862,canEdit:s=!1})=>{const{data:l}=e(),p=l.activeBlockId===r.id,m=a/1052;return t(n,Object.assign({theme:i},{children:t(c,Object.assign({previewWidth:a,zoomFactor:m,canEdit:s},{children:t(d,Object.assign({isActiveBlock:p},{children:t(o,{block:r,canEdit:s})}))}))}))};export{a as default};
